import moment from 'moment';

import { FeatureGateState } from './feature-gate-selectors';
import { FAILURE, STARTING, SUCCESS } from '../action/util/action-name-creators';
import { Action, updateResourceByObjectKey } from '../reducers/utils/state-manager';

const InitialState = {
  featureGatesByUsernameFlag: {},
  featureGatesStateByUsernameFlag: {},
};

export const featureGateReducer = (state: FeatureGateState = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_FEATURE_GATE'): {
      const {
        currentUser: { username },
        gateName,
      } = action.payload.args;
      return updateResourceByObjectKey(
        state,
        'featureGatesByUsernameFlag',
        `${username}-${gateName}`,
        true,
      );
    }
    case SUCCESS('LOAD_FEATURE_GATE'): {
      const {
        args: {
          currentUser: { username },
          gateName,
        },
        data: { isGateEnabled },
      } = action.payload;

      const newFeatureGate = {
        gateName: gateName as string,
        isEnabled: isGateEnabled,
        ttl: moment().add(1, 'day'),
      };

      return updateResourceByObjectKey(
        state,
        'featureGatesByUsernameFlag',
        `${username}-${gateName}`,
        false,
        { [`${username}-${gateName}`]: newFeatureGate },
      );
    }
    case FAILURE('LOAD_FEATURE_GATE'): {
      const {
        currentUser: { username },
        gateName,
      } = action.payload.args;
      return updateResourceByObjectKey(
        state,
        'featureGatesByUsernameFlag',
        `${username}-${gateName}`,
        false,
      );
    }
    default:
      return state;
  }
};
